import { z } from 'zod'
import { listResourceSchema } from '@/types/schema/api/list-resource-schema'
import { collaborativeItemSchema } from '@/types/schema/collaborative/collaborative-item'

export const draftQuotationSchema = z.object({
  name: z.string().min(1),
  item_list: z.array(collaborativeItemSchema),
})
export type DraftQuotation = z.infer<typeof draftQuotationSchema>

export const quotationSchema = draftQuotationSchema.extend({
  id: z.number(),
  start_date: z.string().datetime(),
  total_budget: z.string().transform(Number),
  manager_id: z.number(),
  manager_name: z.string(),
})
export type Quotation = z.infer<typeof quotationSchema>

export interface AddQuotationRequest {
  kolId: string
  quotation: DraftQuotation
}

export interface DeleteQuotationRequest {
  kolId: string
  quotationId: number
}

export interface EditQuotationRequest {
  kolId: string
  quotationId: number
  quotation: DraftQuotation
}

export interface FetchQuotationsRequest {
  kolId: string
  page: number
}

export const customQuotationListSchema = listResourceSchema.extend({
  quotation_list: z.array(quotationSchema),
})
export const fetchCustomQuotationsResponseSchema = z.object({
  data: customQuotationListSchema,
})
export type FetchCustomQuotationsResponse = z.infer<
  typeof fetchCustomQuotationsResponseSchema
>

export const predictiveReportQuotationListSchema = listResourceSchema.extend({
  predictive_report_quotation_list: z.array(quotationSchema),
})
export const fetchPredictiveReportQuotationsResponseSchema = z.object({
  data: predictiveReportQuotationListSchema,
})
export type FetchPredictiveReportQuotationsResponse = z.infer<
  typeof fetchPredictiveReportQuotationsResponseSchema
>
